export var ACCOUNTANCY_NONE_KEY = 'ACT069';